/** Create or update a user. */
export const userSaveSpec = {
    uri: '/user/[user]',
    method: 'PUT',
    adminOnly: true,
};
